import { SetStateAction } from 'react';
import { connect } from 'react-redux';
import { setSearchSectionPage } from 'redux/modules/search';
import { RootState } from 'redux/modules/types';
import {
  SEARCH_VIDEOS_PER_PAGE_DETAIL,
  SEARCH_VIDEOS_PER_PAGE_MASTER,
} from 'utils/config';
import { getPageCount } from 'utils/getPageCount';
import { OwnProps } from './types';

const mapStateToProps = (state: RootState, { isDetail }: OwnProps) => ({
  available: state.search.available.videos,
  count: state.search.count.videos,
  items: state.search.ids.videos
    .map((id) => state.search.byId.videos[id])
    .filter((it): it is NonNullable<typeof it> => !!it),
  loading: state.search.loading.visuals,
  page: state.search.page.videos,
  pageCount: getPageCount(
    state.search.count.videos,
    isDetail ? SEARCH_VIDEOS_PER_PAGE_DETAIL : SEARCH_VIDEOS_PER_PAGE_MASTER,
  ),
});

const mapDispatchToProps = {
  setPage: (page: SetStateAction<number>) =>
    setSearchSectionPage({
      page,
      section: 'videos',
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
